import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "@/utils/route";
import { preload, usePreloaded } from "@/utils/relay";
import { createIntl } from "@/utils/intl";
import { parseRequestSearch } from "@/utils/validation";
import { CompetitionApprovalPageQuery as CompetitionApprovalPageQueryType } from "./__generated__/CompetitionApprovalPageQuery.graphql";
import { schemaFactory } from "@/components/CompetitionApprovals/schema";

export type { CompetitionApprovalPageQuery as CompetitionApprovalPageQueryType } from "./__generated__/CompetitionApprovalPageQuery.graphql";

export const CompetitionApprovalPageQuery = graphql`
  query CompetitionApprovalPageQuery(
    $slug: String!
    $approvalFilter: ApprovalFilter
  ) {
    competitionBySlug(slug: $slug) {
      id
      title
      ...CompetitionJuryFragment
      ...CompetitionScoringCriteriaFragment
      ...CompetitionApprovalsFragment
        @arguments(approvalFilter: $approvalFilter)
    }
  }
`;

export const competitionApprovalPageQueryLoader = (
  environment: Environment,
) => {
  return ({ params: { slug }, request }: LoaderArgs) => {
    if (!slug) {
      throw new Response("No slug", { status: 500 });
    }
    const schema = schemaFactory(createIntl());
    const parsedSearch = parseRequestSearch(schema, request);
    const approvalFilter = parsedSearch.success
      ? parsedSearch.output.approvalFilter
      : undefined;
    return preload<CompetitionApprovalPageQueryType>(
      environment,
      CompetitionApprovalPageQuery,
      {
        slug,
        approvalFilter,
      },
    );
  };
};

export const useCompetitionApprovalPageQuery = () =>
  usePreloaded<CompetitionApprovalPageQueryType>();
